import Select from 'react-select';
import { SingleFilterClause } from 'store/composableFiltersSlice';

interface OperatorFieldProps {
  selectOptions: any;
  filterState: SingleFilterClause;
  handleUpdateOperatorField: Function;
  placement: 'single' | 'group';
}

export const OperatorField = ({
  selectOptions,
  filterState,
  handleUpdateOperatorField,
  placement,
}: OperatorFieldProps) => {
  const fieldWidth = placement === 'single' ? 'w-36' : 'w-32';

  const selectBaseStyles = {
    input: (base: any) => ({
      ...base,
      'input:focus': {
        boxShadow: 'none',
      },
    }),
    control: (base: any) => ({
      ...base,
      backgroundColor: '#F8F8F8',
      border: 'none',
      borderRadius: '8px',
      height: '48px',
      textTransform: 'capitalize',
    }),
    menu: (base: any) => ({
      ...base,
      textTransform: 'capitalize',
      width: '150px',
    }),

    indicatorSeparator: () => ({}),
    valueContainer: (base: any) => ({
      ...base,
      paddingLeft: '16px',
    }),
  };

  return (
    <Select
      key={String(filterState.value)}
      value={
        filterState.operator?.name === ''
          ? null
          : {
              value: filterState.operator?.name,
              label: filterState.operator?.display,
            }
      }
      options={selectOptions.operators}
      className={` ${fieldWidth}`}
      isDisabled={!!!filterState.property?.name || !!!selectOptions.type}
      placeholder="Operator..."
      isSearchable={false}
      styles={selectBaseStyles}
      onChange={(selectedOption) => handleUpdateOperatorField(selectedOption)}
    />
  );
};
